module.exports = __webpack_public_path__ + "img/marker.8f5992ce.svg";